<template>
  <div
    class="Background"
    :style="{ backgroundImage: url }"
    @dblclick="selectBackgroundImage"
  ></div>
</template>
<script>
export default {
  computed: {
    url() {
      return this.$store.getters['images/getBackgroundUrl'](
        this.$store.getters['room/table'].backgroundImageKey
      )
    },
    role() {
      return this.$store.getters['local/role']
    },
    tableScale() {
      return this.$store.getters['local/tableScale']
    }
  },
  methods: {
    selectBackgroundImage() {
      if (this.role <= 5) return
      this.$store.commit('selectors/open', {
        tags: ['scenes'],
        action: 'room/$set',
        context: { key: 'tableBackgroundImageKey' }
      })
    }
  }
}
</script>

<style scoped>
.Background {
  margin: -8px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* z-index: -1; */
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  filter: blur(8px);
}
</style>
